/** Login Id of the last user logged in */
export const LOCAL_STORAGE_LAST_USER_LOGIN_ID = 'dls_last_user_login_id';

/** Display name of the last user logged in */
export const LOCAL_STORAGE_LAST_USER_DISPLAY_NAME =
  'dls_last_user_display_name';
